import { createAction } from '@reduxjs/toolkit'
import { TQuestForm } from 'domain/types'

export const setQuestState = createAction<TQuestForm>('quest/setQuestState')
